var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTvPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 300 300"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "tv_play_svg__a",
  d: "M252.6 130.8 73.2 11.4c-15.3-10.2-36 .9-36 19.2v238.5c0 18.6 20.7 29.4 36 19.2l179.4-119.4c13.5-8.7 13.5-29.1 0-38.1Z"
})));
export { SvgTvPlay as ReactComponent };
export default __webpack_public_path__ + "static/media/tv_play.3f5d2d19.svg";